/**
     * @desc 查询BROWSE页作品集列表
用于BROWSE页左侧collection列表
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/collection/getBrowseCollectionList', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/collection/getBrowseCollectionList', params);
}
